import { createStore } from 'vuex'
import modules from './modules'
import { crud, sortable, searchable, autocomplete, accessible, selectable } from "./generator";
const _ = require("lodash");
import cloneDeep from 'lodash-es/cloneDeep';

const crudModules = crud({
  components: 'admin/components',
  templates: 'admin/therapy-templates',
  medicines: 'admin/medicines',
  auditEvents: 'admin/audit-events',
  drafts: 'doctor/therapy-drafts'
})

const sortableModules = sortable({
  //
})

const searchableModules = searchable({
  //
})

const autocompleteModules = autocomplete({
  //
})

const accessibleModules = accessible({
  //
});

const selectableModules = selectable({
  //
});

const merged = _.merge(crudModules, sortableModules, searchableModules, autocompleteModules, accessibleModules, selectableModules, modules)

// eslint-disable-next-line no-unused-vars
const store = createStore({
  modules: merged,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

const initialState = cloneDeep(store.state);

store.reset = function () {
    store.replaceState(initialState);
};

export default store;
